import { Route, Routes, Navigate } from 'react-router-dom';
import Index from './pages/Index';
import Index2 from './pages/Index2';

const DashboardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/index" element={<Index />} />
      <Route path="/old" element={<Index2 />} />
      <Route path="*" element={<Navigate to="/app/dashboard/index" />} />
    </Routes>
  );
};

export default DashboardRoutes;
